export default __webpack_public_path__ + "static/media/smile-detail.db8f52a7.svg";